import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faLongArrowAltUp,
  faLongArrowAltDown,
} from '@fortawesome/free-solid-svg-icons';

const DISPLAY_MAP = new Map([
  ['Detected At', 'DetectedAt'],
  ['Resolved', 'TriggeredAt'],
]);

function SortByDateButton({ displayText, sort, handleSortClick }) {
  const isActiveSort = DISPLAY_MAP.get(displayText) === sort.by;

  return (
    <button
      className="btn btn-link text-decoration-none three-quarter-text text-text-light-gray d-flex align-items-center justify-content-between p-0 w-100"
      onClick={() => handleSortClick(DISPLAY_MAP.get(displayText))}
    >
      <span>{displayText}</span>
      <div>
        {[
          [faLongArrowAltUp, 'ASC'],
          [faLongArrowAltDown, 'DESC'],
        ].map(([icon, sortDir]) => (
          <FontAwesomeIcon
            key={sortDir}
            icon={icon}
            className={
              isActiveSort && sort.direction === sortDir
                ? 'text-text-light-gray font-weight-normal'
                : 'text-icon-link-gray font-weight-light'
            }
            style={{ margin: '0 0.1rem' }}
          />
        ))}
      </div>
    </button>
  );
}

SortByDateButton.propTypes = {
  displayText: PropTypes.oneOf(['Detected At', 'Duration', 'Resolved']),
  sort: PropTypes.shape({
    by: PropTypes.oneOf(['TriggeredAt', 'DetectedAt']),
    direction: PropTypes.oneOf(['ASC', 'DESC']),
  }),
  handleSortClick: PropTypes.func,
};

SortByDateButton.defaultProps = { sort: {} };

export default memo(SortByDateButton);
